import React, { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import FolderTree from "../FolderTree";
import Utils from "../../../../Utils";
import ContextComponent from "../../../../AppContext";

const MoveSitePage = ({ props }) => {
  let [siteDataforMove, setSiteDataforMove] = useState(props.siteContent || []);
  let [selectedSiteIds, setSelectedSiteIds] = useState(props.tableSelectedItems);
  let [selectedFolderId, setSelectedFolderId] = useState(null);
  let numberOfSelectedSites = selectedSiteIds.length;
  const {
    moveModalCanOpen: show,
    setMoveModalCanOpen,
    currentFolderId,
  } = props;
  const { setLoadingState, setAlert, setCanRedirectToLogin } =
    useContext(ContextComponent);
    let [expandedFolders, setExpandedFolders] = useState([]);

  const handleClose = () => {
    setMoveModalCanOpen(false);
  };

  const handleSubmit = (e) => {
    if (siteDataforMove) {
      moveSites(e);
    }
  };

  const moveSites = (e) => {
    setLoadingState({
      applyMask: true,
      text: "Moving sites...",
    });
    const success = (res) => {
      handleClose();
      setLoadingState({
        applyMask: false,
      });
      setAlert({
        show: true,
        message: "Sites moved successfully!",
        type: "success",
      });
      setSelectedSiteIds([]);
      props.loadProjectSites();
    };
    const fail = (err) => {
      setLoadingState({
        applyMask: false,
      });
      if (err?.redirect) {
        setCanRedirectToLogin(true);
      }
      setAlert({
        show: true,
        message: "Sites moving failed",
        type: "danger",
      });
      console.log(err);
    };

    try {
      Utils.moveSites(selectedSiteIds, selectedFolderId).then(success, fail);
      console.log("Sites moved successfully!");
      handleClose();
    } catch (err) {
      console.error("Error moving sites", err);
    }
  };

  const toggleFolder = (folderId) => {
    setExpandedFolders(prev => {
      if (prev.includes(folderId)) {
        return prev.filter(id => id !== folderId);
      }
      return [...prev, folderId];
    });
  };

  const isMoveEnabled = numberOfSelectedSites > 0 && selectedFolderId;

  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="indi-move-site-modal-title">Move Sites here</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="indi-move-sites-wrapper">
            <span className="indi-move-sites-left-section-title">
              Moving {numberOfSelectedSites} Site{numberOfSelectedSites > 1 ? "s" : ""}...
            </span>

            <div className="indi-move-sites-right-section">
              <FolderTree
                selectionMode="single"
                selectedFolderId={selectedFolderId}
                setSelectedFolderId={setSelectedFolderId}
                currentFolderId={currentFolderId}
                expandedFolders={expandedFolders}
                toggleFolder={toggleFolder}
                type={props?.type}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={!isMoveEnabled}
          >
            Move
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MoveSitePage;
